var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.75 12H2.75V2H9.75L8.75 1H2.75C2.19687 1 1.75 1.44687 1.75 2V12C1.75 12.5531 2.19687 13 2.75 13H4.75V12ZM15.75 6L12.75 3H6.75C6.19688 3 5.75 3.44688 5.75 4V14C5.75 14.5531 6.19688 15 6.75 15H14.75C15.3031 15 15.75 14.5531 15.75 14V6ZM14.75 14H6.75V4H11.75V7H14.75V14Z",
    fill: "#0078D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultCopyIcon);
export default __webpack_public_path__ + "static/media/defaultCopyIcon.aa2403fe294a791cf465681126db8bd7.svg";
export { ForwardRef as ReactComponent };